import React from 'react';
import Logs from '../components/Logs';

function LogsPage() {
  return (
    <Logs />
  );
}

export default LogsPage;
